import keys from 'lodash/keys';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import map from 'lodash/map';
import reduce from 'lodash/reduce';
import get from 'lodash/get';
import some from 'lodash/some';
import includes from 'lodash/includes';
import {getDefaultActiveLanguage, getMountedLanguages} from './mountedLanguages';

const LOCALES = getMountedLanguages();
const LOCALE_DEFAULT = getDefaultActiveLanguage();

export const isValidValueToTranslate = (value) => {
  return (
    isObject(value)
  );
};

export const isSubArray = (sub, arr) => some(sub, v => includes(arr, v));

export const createLocalized = (locale, locales = LOCALES, localeDefault = LOCALE_DEFAULT) => {
  if (!locales.includes(locale)) {
    locale = localeDefault || locales[0];
  }

  function translate(rawData) {
    if (!isValidValueToTranslate(rawData)) {
      return rawData;
    }
    if (isArray(rawData)) {
      return map(rawData, translate);
    } else if (isObject(rawData)) {
      if (get(rawData, locale)) {
        return get(rawData, locale);
      } else if (isSubArray(keys(rawData), locales)) {
        return null;
      } else {
        return reduce(rawData, (acc, value, key) => {
          return {
            ...acc,
            [key]: translate(value)
          };
        }, {});
      }
    }
  }

  return translate;
};
